import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import HomePageOne from "./adminPages/HomePageOne";
import ErrorPage from "./adminPages/ErrorPage";
import SignInPage from "./adminPages/SignInPage";
import SignUpPage from "./adminPages/SignUpPage";
import AccessDeniedPage from "./adminPages/AccessDeniedPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ManagePackages from "./adminPages/ManagePackages";
import ManageClients from "./adminPages/ManageClients";
// import AddClientPage from "./adminPages/AddClientPage";
// import AddPackagePage from "./adminPages/AddPackagePage";
// import EditPackagePage from "./adminPages/EditPackagePage";
// import EditClientPage from "./adminPages/EditClientPage";
// import ManageInvoices from "./adminPages/ManageInvoices";
// import CreateInvoicePage from "./adminPages/CreateInvoicePage";
import LoginHistoryPage from "./adminPages/LoginHistoryPage";
import ClientPackagesPage from "./clientPages/ClientPackagesPage";
import ProtectedRoute from "./components/ProtectedRoute";
import MyPackagesPage from "./clientPages/MyPackagesPage";
import PaymentHistoryPage from "./clientPages/PaymentHistoryPage";
import EditProfilePage from "./clientPages/EditProfilePage";
import ManageServices from "./adminPages/ManageServices";
import ContactFormEntries from "./adminPages/ContactFormEntries";

function App() {
  useEffect(() => {
    // Check token validity on app load
    const checkTokenValidity = async () => {
      const token = localStorage.getItem("token");
      
      if (!token) {
        // No token, user must login
        return;
      }

      // Optional: Verify token is still valid by making a test API call
      // This helps catch expired tokens proactively
      try {
        const response = await fetch("https://clearshine.koderspedia.online/verify-token", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 401) {
          // Token expired - logout user
          console.warn("Token expired during startup");
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          localStorage.removeItem("user");
          localStorage.removeItem("userId");
          window.location.href = "/";
        }
      } catch (error) {
        console.error("Token verification error:", error);
        // Don't logout on network errors, let API calls handle it
      }
    };

    checkTokenValidity();
  }, []);

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>

        {/* Public Routes */}
        <Route path='/' element={<SignInPage />} />
        <Route path='/signup' element={<SignUpPage />} />
        <Route path='/access-denied' element={<AccessDeniedPage />} />

        {/* Admin Protected Routes */}
        <Route path='/dashboard' element={<ProtectedRoute element={HomePageOne} allowedRole="admin" />} />
        <Route path='/bookings' element={<ProtectedRoute element={ManagePackages} allowedRole="admin" />} />
        <Route path='/manage-clients' element={<ProtectedRoute element={ManageClients} allowedRole="admin" />} />
        {/* <Route path='/add-client' element={<ProtectedRoute element={AddClientPage} allowedRole="admin" />} /> */}
        {/* <Route path='/add-package' element={<ProtectedRoute element={AddPackagePage} allowedRole="admin" />} /> */}
        {/* <Route path='/edit-package' element={<ProtectedRoute element={EditPackagePage} allowedRole="admin" />} /> */}
        {/* <Route path='/edit-client' element={<ProtectedRoute element={EditClientPage} allowedRole="admin" />} /> */}
        {/* <Route path='/manage-invoice' element={<ProtectedRoute element={ManageInvoices} allowedRole="admin" />} /> */}
        {/* <Route path='/create-invoice' element={<ProtectedRoute element={CreateInvoicePage} allowedRole="admin" />} /> */}
        <Route path='/login-history' element={<ProtectedRoute element={LoginHistoryPage} allowedRole="admin" />} />
        <Route path="/services" element={<ProtectedRoute element={ManageServices} allowedRole="admin" />} />
        <Route path="/contact-form" element={<ProtectedRoute element={ContactFormEntries} allowedRole="admin" />} />
        {/* Client Protected Routes */}
        <Route path='/all-packages' element={<ProtectedRoute element={ClientPackagesPage} allowedRole="client" />} />
        <Route path='/my-packages' element={<ProtectedRoute element={MyPackagesPage} allowedRole="client" />} />
        <Route path='/payment-history' element={<ProtectedRoute element={PaymentHistoryPage} allowedRole="client" />} />
        <Route path='/edit-profile' element={<ProtectedRoute element={EditProfilePage} allowedRole="client" />} />

        {/* Fallback */}
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
